import React, { useState } from 'react';

const Toggle = ({ label="Include in Monthly", onChange, value, labelClass }) => {
  const [isToggled, setIsToggled] = useState(value);

  const handleToggleChange = () => {
    setIsToggled(!isToggled);
  };

  return (
    <div className="flex items-center space-x-2">
      <span className={`text-sm font-medium ${labelClass}`}>{label}</span>
      <button
        className={`relative inline-flex items-center justify-center w-7 h-4 rounded-full transition-all ${
          isToggled ? 'bg-blue-500' : 'bg-gray-300'
        }`}
        onClick={() => {handleToggleChange(); onChange(!isToggled);}}
      >
        <span
          className={`absolute left-px top-px block w-3.5 h-3.5 bg-white rounded-full transition-all ${
            isToggled ? 'transform translate-x-3' : ''
          }`}
        />
      </button>
    </div>
  );
};

export default Toggle;
